import { useContext, useEffect, useRef } from "react";
import { references } from "../../context/ref";
import { context } from "../../context/context";
import { switchh } from "../../context/switch";
import { action } from "../../context/action";
import { intialData } from "../../context/initial";
import { dataa } from "../../context/data";
import { scenes } from "../../context/scenes";

export default function useShortKeys () {
    const { SerialInput, SearchInput, CashingBtn } = useContext(references);
    const { cart, setCart, setPointer, setEdit, pointer, setDeleteBox, resetDeleteBox } = useContext(context);
    const { setEnableDelivery, setEnableAttendance, setAccess, setEnableSendResetCode, setEnableAddWeightManully, intialAddWeightManually } = useContext(switchh);
    const { setEnablePayOnline } = useContext(action);
    const { initResetPayOnline } = useContext(intialData);
    const { setScene, setShowData } = useContext(dataa);
    const { setSceneEmp } = useContext(scenes);

    // to not select on any one
const indexRef = useRef(0);

const ResetAll = () => {
    indexRef.current = 0;
    setPointer({});
    setSceneEmp({})
    setEdit({});
    setScene([]);
    setShowData([])
    setEnableDelivery(false);
    setEnableAttendance(false);
    setAccess(false);
    setEnableSendResetCode(false);
    setEnablePayOnline(initResetPayOnline);
    setDeleteBox(resetDeleteBox);
    setEnableAddWeightManully(intialAddWeightManually);
}

useEffect(() => {
    const ShortKeylistener = (event) => {
        const code = event?.code;
        
        const reservedKeys = [
            "NumpadDivide",
            "NumpadMultiply",
            "NumpadSubtract",
            "NumpadAdd",
            "NumpadDecimal",
            "Escape",
            "F2"
        ];

        if (reservedKeys.includes(code)) {
            event.preventDefault();
        }

        switch (code) {
            case "NumpadSubtract":
                if(SerialInput.current) {
                    SerialInput.current.focus();
                }
                break;

            case "NumpadDivide":
                if(SearchInput.current) {
                    SearchInput.current.focus();
                }
                break;

            case "NumpadMultiply":
                if (indexRef.current < cart.length) {

                    let select = cart[indexRef.current];

                    if (select) {
                        setPointer(select);
                    }

                    indexRef.current++;

                } else {
                    indexRef.current = 0;
                }
                break;

            case "NumpadAdd":
                if (Object.keys(pointer).length === 0) return;
                setEdit(pointer);
                break;

            case "NumpadDecimal": 
                const remainsCart = [];
                cart.filter((item) => item.id !== pointer.id)
                .map((select) => remainsCart.push(select))
                setCart(remainsCart);
                break;

            case "Escape":
                ResetAll();
                break;
            case "F2":
                if(CashingBtn.current) {
                    CashingBtn.current.click();
                }
                break;
        }
    };

    window.addEventListener("keydown", ShortKeylistener);

    return () => {
        window.removeEventListener("keydown", ShortKeylistener);
    };
}, [cart, pointer]);
}